<template>
  <admin-input-row v-bind="dataInput" class="pt-2" :disabled="!isEnabled">
    <template #upload.input>
      <v-row no-gutters v-if="added">
        <v-col
          cols="auto"
          class="text-left"
          :class="{
            'text--disabled': !isEnabled,
          }"
        >
          {{ version }}
          <v-row no-gutters>
            <v-col cols="auto">
              <italic-subheader
                :class="{
                  'text--disabled': !isEnabled,
                }"
                translation-path="admin.addDate"
                :params="{ date: formattedDate }"
              ></italic-subheader>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="auto" class="pl-10" v-if="hasDeleteButton">
          <base-button
            small
            :disabled="!isEnabled"
            @click="$emit('deleteFile')"
            translation-path="menu.delete"
            :loading="deleteLoading"
          ></base-button>
        </v-col>
        <v-col cols="auto" :class="hasDeleteButton ? 'pl-4' : 'pl-10'">
          <base-button
            small
            translation-path="admin.uploadNewVersion"
            @click="$emit('showUpload')"
            :disabled="!isEnabled"
          ></base-button>
        </v-col>
      </v-row>
      <base-button
        v-else
        small
        translation-path="admin.upload"
        @click="$emit('showUpload')"
        :disabled="!isEnabled"
      ></base-button>
    </template>
  </admin-input-row>
</template>

<script>
import AdminInputRow from '@/components/AdminInputRow';
import BaseButton from '@/components/BaseButton';
import ItalicSubheader from '@/components/ItalicSubheader';

export default {
  name: 'SuperAdminUploadRow',
  components: { AdminInputRow, BaseButton, ItalicSubheader },
  props: {
    isEnabled: {
      type: Boolean,
      required: true,
    },
    added: {
      type: Boolean,
      required: true,
    },
    dataInput: {
      type: Object,
      default: () => {},
    },
    hasDeleteButton: {
      type: Boolean,
      default: false,
    },
    version: {
      type: String,
      default: '',
    },
    dateUploaded: {
      type: String,
      default: '',
    },
    deleteLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    formattedDate() {
      if (!this.dateUploaded) {
        return;
      }
      return this.$dayjs(this.dateUploaded).format('L');
    },
  },
};
</script>
